import React, { FC } from 'react';

interface IDropdownItem {
    name: string;
    label: string;
    countryCode: string;
    setInputValue: (state: any) => void;
    setFormData: (state: any) => void;
    setFormErrors: (state: any) => void;
    onDropdownClose?: () => void;
}

const DropdownItem: FC<IDropdownItem> = ({ name, label, countryCode, setInputValue, setFormData, setFormErrors, onDropdownClose }: IDropdownItem) => {

    const onCLickHandler = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        setInputValue(label);

        setFormData((state: any) => {
            return {
                ...state,
                [name]: label,
            }
        });

        setFormErrors && setFormErrors((state: any) => {
            return {
                ...state,
                [name]: ''
            }
        });

        onDropdownClose && onDropdownClose();
    };

    return (
        <li
            className="select-city__dropdown-item"
            onClick={onCLickHandler}
        >
            <div className={`flag-icon flag-icon-${countryCode.toLowerCase()}`}/>
            <div>{label}</div>
        </li>
    );
};

export default DropdownItem;
